<template>
    <div id="deadReasonCommentModal" class="modal fade" role="dialog">
        <div class="modal-dialog" style="max-width: 870px">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-lg">Required comment for: Dead Sales Status</h4>
                    <button type="button" dusk="modal-close-button"
                            class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                            data-dismiss="modal" @click="close()">close
                    </button>
                </div>
                <div class="modal-body">
                    <form @keydown="projectCommentForm.errors.clear($event.target.name)">
                        <div v-if="deadReasonCustomField" class="d-flex flex-row w-full mb-3 mt-2">
                            <strong class="w-1/5 m-auto">{{ deadReasonCustomField.label_value }}: </strong>
                            <multiselect
                                class="cursor-pointer appearance-none focus:outline-none rounded text-grey-darkest text-sm w-2/3 field-height-update"
                                :options="deadReasonCustomField.options"
                                v-model="projectCommentForm.deadReason"
                                :show-labels="false"
                                track-by="id"
                                label="name"
                                value="id">
                            </multiselect>
                        </div>
                        <div class="mb-2">
                            <ckeditor-container id="comment" v-model="projectCommentForm.comment" :options="users"
                                                @mention="addMention" mentionFrom="name"></ckeditor-container>
                            <div class="text-red text-xs" v-if="projectCommentForm.errors.has('comment')">{{
                                    projectCommentForm.errors.get('comment')
                                }}
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                        <span v-if="this.projectCommentForm.saving">
                            <button type="button" disabled
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                <i class="fa fa-btn fa-spinner fa-spin"></i> Saving
                            </button>
                        </span>
                    <span v-else>
                            <button type="button" id="save-project-comment" name="save-project-comment"
                                    @click.prevent="store"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Save
                            </button>
                        </span>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import Form from "../../../utils/form";
export default {
    name: 'dead-reason-comment',
    props: ['bulkSelectedProjects', 'deadReasonCustomField', 'users'],
    components: {Multiselect},
    data() {
        return {
            projectCommentForm: new Form({
                projects: this.bulkSelectedProjects ? this.bulkSelectedProjects : [],
                comment: '',
                mentioned_users: [],
                saving: false,
                deadReason: null
            }),
        }
    },
    watch: {
        'this.bulkSelectedProjects': function() {
            this.projectCommentForm.projects = this.bulkSelectedProjects;
        }
    },
    methods: {
        open() {
            $("#deadReasonCommentModal").modal("show");
        },
        close() {
            $("#deadReasonCommentModal").modal("hide");
            this.projectCommentForm.reset();
        },
        addMention(replaced) {
            if (_.find(this.projectCommentForm.mentioned_users, o => o === replaced.id)) {
                return;
            }
            this.projectCommentForm.mentioned_users.push(replaced.id);
        },
        store() {
            let self = this;
            self.projectCommentForm.saving = true;
            self.projectCommentForm.post(route('api.project.mass-update.add-dead-reason-comment')).then((res) => {
                self.projectCommentForm.saving = false;
                self.close();
                window.location.reload();
            }).catch((error) => {
                console.log(error)
            });
        }
    }
}
</script>
